import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Badge } from 'reactstrap';
import { Loader } from '..';
import { updateUi } from '../../redux';

import './HealthCheckIcon.css';

const HealthCheckIcon = () => {
    const dispatch = useDispatch();
    const { t }    = useTranslation();

    const showHealthChecksPanel = () => {
        dispatch(updateUi({ showHealthChecks: true }));
    };

    const { log, isLoading } = useSelector(state => state.health);

    const nbFailed = useMemo(() => {
        return Object.keys(log?.results || {}).reduce((nb, group) => {
            return (nb += log.results[group].filter(t => !t.result).length);
        }, 0);
    }, [log]);

    if (!isLoading && !log)
        return null;

    return (
        <div className="HealthCheckIcon">
            <h5>
                <Badge color={nbFailed > 0 ? 'danger' : 'success'} onClick={showHealthChecksPanel}>
                    <i className={`fa  ${isLoading ? 'fa-spinner fa-spin' : nbFailed > 0 ? 'fa-warning' : 'fa-check'}`} />
                </Badge>
            </h5>
        </div>
    );
}

export default HealthCheckIcon;
